import { useMemo, useState } from 'react';
import SectionHeading from './SectionHeading';
import { genreItems } from '@/mocks/genres';

const allTags = ['全部', '悬疑', '犯罪', '都市', '家庭', '年代', '古装', '历史', '爱情', '科幻', '职场', '治愈', '冒险'];

export default function GenreExplore() {
  const [keyword, setKeyword] = useState('');
  const [activeTag, setActiveTag] = useState('全部');

  const filtered = useMemo(() => {
    const kw = keyword.trim();
    return genreItems.filter((item) => {
      const matchTag = activeTag === '全部' || item.tags.includes(activeTag);
      const matchKeyword = kw === '' || item.title.includes(kw) || item.note.includes(kw);
      return matchTag && matchKeyword;
    });
  }, [keyword, activeTag]);

  return (
    <section id="genre" className="scroll-mt-16 bg-background-50 py-14 md:py-20 border-t border-background-200/70">
      <div className="px-4 md:px-8">
        <SectionHeading
          icon="ri-filter-3-line"
          eyebrow="类型探索"
          title="类型探索：用关键词与标签在本页快速筛选"
          desc="下列筛选只作用于本页已展示的条目，不会联网请求。输入剧名关键词，或点击类型标签，即可实时得到匹配结果，并显示命中条目数量。"
        />

        <div className="mt-8 p-4 md:p-5 rounded-lg bg-background-100 border border-background-200">
          <div className="flex flex-col sm:flex-row gap-3">
            <div className="relative flex-1">
              <span className="absolute left-3 top-1/2 -translate-y-1/2 flex items-center justify-center w-5 h-5 text-foreground-400">
                <i className="ri-search-line text-sm"></i>
              </span>
              <input
                type="text"
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                placeholder="输入剧名或看点关键词，如「悬疑」「星河」"
                className="w-full pl-10 pr-4 py-2.5 text-sm rounded-md bg-background-50 border border-background-300 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400"
              />
            </div>
            <div className="flex items-center gap-2 px-4 py-2.5 rounded-md bg-secondary-100 text-secondary-900">
              <i className="ri-list-check-2"></i>
              <span className="text-sm whitespace-nowrap">命中 {filtered.length} 条</span>
            </div>
          </div>

          <div className="mt-4 flex flex-wrap gap-2">
            {allTags.map((tag) => {
              const isActive = tag === activeTag;
              return (
                <button
                  key={tag}
                  type="button"
                  onClick={() => setActiveTag(tag)}
                  aria-pressed={isActive}
                  className={`px-3 py-1.5 text-xs font-medium whitespace-nowrap rounded-full cursor-pointer transition-colors ${
                    isActive
                      ? 'bg-accent-500 text-background-50'
                      : 'bg-background-50 text-foreground-700 border border-background-300 hover:bg-accent-100'
                  }`}
                >
                  {tag}
                </button>
              );
            })}
          </div>
        </div>

        <div className="mt-6">
          {filtered.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
              {filtered.map((item) => (
                <div
                  key={item.id}
                  className="flex flex-col p-4 rounded-lg bg-background-100 border border-background-200"
                >
                  <div className="flex items-center justify-between gap-2">
                    <h3 className="font-heading text-sm font-bold text-foreground-950">{item.title}</h3>
                    <span className="shrink-0 px-2 py-0.5 text-xs rounded-md bg-primary-100 text-primary-700">
                      {item.type}
                    </span>
                  </div>
                  <p className="mt-2 text-xs leading-5 text-foreground-600">{item.note}</p>
                  <div className="mt-3 flex flex-wrap gap-1.5">
                    {item.tags.map((tag) => (
                      <span
                        key={tag}
                        className="px-2 py-0.5 text-xs rounded-full bg-secondary-100 text-secondary-900"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center py-14 rounded-lg bg-background-100 border border-background-200">
              <span className="flex items-center justify-center w-12 h-12 rounded-full bg-background-200 text-foreground-500">
                <i className="ri-search-eye-line text-xl"></i>
              </span>
              <p className="mt-4 text-sm font-medium text-foreground-800">没有找到匹配的条目</p>
              <p className="mt-1 text-xs text-foreground-500">试试更换关键词，或点击「全部」查看所有条目。</p>
              <button
                type="button"
                onClick={() => {
                  setKeyword('');
                  setActiveTag('全部');
                }}
                className="mt-4 px-4 py-2 text-sm whitespace-nowrap rounded-md bg-primary-500 text-background-50 cursor-pointer transition-colors hover:bg-primary-600"
              >
                重置筛选
              </button>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}